

















































import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '../../mixins/pagination'
import { SearchItemType, TableColumnItemType, OperationItemType, OptionItemType } from '../../types/type'
import { CommonModule, UserModule, CanteenModule } from '../../store'
import { getAllFatherNodeForTree, disposeSearchParamsForCM } from '../../utils/toolsForCommon'
@Component({
  name: 'InventoryRecords',
  mixins: [Pagination],
  components: {
    'search-module': () => import('../../components/common/searchModule.vue'),
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../components/common/tableModule.vue')
  }
})
export default class InventoryRecords extends Vue {
  public loading = false
  // 搜索条件的最终选中项：
  public searchCheckList: Array<string> = []
  // 所有搜索条件：
  public searchList: Array<SearchItemType> = [
    {
      title: '学校',
      key: 'organizationName',
      type: 'cascader',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      show: true,
      disabled: true
    },
    {
      title: '入/出库时间',
      key: 'dateInterval',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择入/出库时间',
      show: true,
      disabled: false
    },
    {
      title: '科目',
      key: 'subject',
      type: 'cascaderForcode',
      value: '',
      placeholder: '请选择科目',
      treeData: [],
      show: true,
      disabled: false
    },
    {
      title: '商品名称',
      key: 'goodName',
      type: 'input',
      value: '',
      placeholder: '请输入商品名称',
      show: true,
      disabled: false
    },
    {
      title: '品牌',
      key: 'brand',
      type: 'input',
      value: '',
      placeholder: '请输入品牌',
      show: true,
      disabled: false
    },
    {
      title: '生产厂家',
      key: 'manufactureFactory',
      type: 'input',
      value: '',
      placeholder: '请输入生产厂家',
      show: true,
      disabled: false
    }
  ]
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '学校',
      key: 'orgId',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum',
      width: '200px'
    },
    {
      title: '入/出库类型',
      key: 'outOrIn',
      type: 'tag',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '入/出库时间',
      key: 'createdTime',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    {
      title: '科目',
      key: 'subject',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum',
      width: '200px'
    },
    {
      title: '商品名称',
      key: 'goodName',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '金额（元）',
      key: 'money',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '数量',
      key: 'amount',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '单位',
      key: 'unit',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '生产日期',
      key: 'manufactureDate',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    {
      title: '保质期（天）',
      key: 'expirationDay',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '120px'
    },
    {
      title: '品牌',
      key: 'brand',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    {
      title: '条码',
      key: 'code',
      type: 'image',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '生产厂家',
      key: 'manufactureFactory',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    {
      title: '入/出库单据',
      key: 'voucher',
      type: 'image',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '备注',
      key: 'comment',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '删除',
      key: 'delete',
      type: 'danger',
      size: 'mini'
    }
  ]

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get userInfo () {
    return UserModule.userInfo
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization(),
      CanteenModule.getTreeDataForDisposeNameSubject()
    ])
    this.disposeSearchCheckedInit()
    this.disposeForSearchList()
    this.getTableDataList()
  }

  // 选择项初始化：
  disposeSearchCheckedInit () {
    // this.searchCheckList = this.searchList.length > 2 ? this.searchList.slice(0, 2).map(item => item.key) : this.searchList.slice(0).map(item => item.key)
    this.searchCheckList = this.searchList.slice(0).map(item => item.key)
  }

  // 选择项数据处理：
  disposeForSearchList () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        case 'organizationName':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
        case 'subject':
          item.treeData = this.treeDataForDisposeNameSubject
          break
      }
      return item
    })
  }

  canteenInventoryAddOrUpdate (id: string, inOrOut: number) {
    this.$router.push({
      name: 'AddOrUpdateCanteenInventory',
      query: {
        id,
        inOrOut: String(inOrOut)
      }
    })
  }

  // 操作按钮：
  operationForButton ({ key }, row) {
    const { id, outOrIn } = row
    switch (key) {
      case 'delete':
        this.operationForDelete(id)
        break
    }
  }

  // 删除：
  operationForDelete (id: string) {
    this
      .$confirm('确定要删除此库存记录吗?', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消删除',
        type: 'error'
      })
      .then(async () => {
        let { data: result } = await (this as any).$http.inventoryDelInventory({ id })
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success('删除成功！')
        this.getTableDataList()
      })
      .catch(() => {})
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
      const params = {
        ...pageParams,
        ...searchParams
      }
      const { data: result } = await (this as any).$http.inventoryQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item.tagType = item.outOrIn ? 'danger' : 'success'
        item.outOrIn = item.outOrIn ? '出库' : '入库'
        item.createdTime = (item.createdTime || '暂无').split(' ')[0]
        return item
      })
      _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  resetBtn () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        case 'organizationName':
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
        default:
          item.value = ''
          break
      }
      return item
    })
  }

  searchBtn (searchCheckListSelf) {
    let _that: any = this
    _that.currentPage = 1
    _that.pageSize = 10
    this.searchCheckList = searchCheckListSelf
    this.getTableDataList()
  }
}
